import { useTranslation } from 'react-i18next';
import type { ThreePlReportDefinition } from '../../models/reports';
import { ReportListRow } from './ReportListRow';

interface ReportsListProps {
  reports: ThreePlReportDefinition[];
  exportingReportId: string | null;
  onGenerate: (report: ThreePlReportDefinition) => void;
}

export function ReportsList({ reports, exportingReportId, onGenerate }: ReportsListProps) {
  const { t } = useTranslation('threePlExcelReportsModule');

  return (
    <div
      className="overflow-hidden rounded-lg border border-border bg-card transition-colors"
      data-testid="three-pl-reports-list"
    >
      <div className="hidden border-b border-border bg-muted/30 px-4 py-2.5 text-xs font-medium uppercase tracking-wide text-muted-foreground sm:grid sm:grid-cols-[1fr_auto] sm:gap-3">
        <span>{t('list.headerName')}</span>
        <span className="text-right">{t('list.headerAction')}</span>
      </div>

      {reports.map((report, index) => (
        <ReportListRow
          key={report.id}
          report={report}
          isLast={index === reports.length - 1}
          isGenerating={exportingReportId === report.id}
          onGenerate={onGenerate}
        />
      ))}
    </div>
  );
}
